import { chatbotHttp as api } from "./chatbotApi";

const base = (botId) => `/bots/${botId}/customer-imports`;
const unwrap = (response) => response.data.data;
export const listCustomerImports = (botId, offset = 0) => api.get(base(botId), { params: { offset } }).then(unwrap);
export const getCustomerImport = (botId, id, params = {}) => api.get(`${base(botId)}/${id}`, { params }).then(unwrap);
export const uploadCustomerImport = (botId, file, source, key) => {
  const body = new FormData();
  body.append("upload", file);
  body.append("source_system", source);
  body.append("idempotency_key", key);
  return api.post(base(botId), body, { headers: { "Content-Type": "multipart/form-data" } }).then(unwrap);
};
export const stageCustomerImport = (botId, id, body) => api.post(`${base(botId)}/${id}/mapping`, body, { timeout: 120000 }).then(unwrap);
export const correctCustomerImportRow = (botId, id, rowId, body) => api.patch(`${base(botId)}/${id}/rows/${rowId}`, body).then(unwrap);
export const runCustomerImport = (botId, id, rowIds = []) => api.post(`${base(botId)}/${id}/run`, { row_ids: rowIds }, { timeout: 120000 }).then(unwrap);
export const getCustomerImportAttempts = (botId, id, rowId) => api.get(`${base(botId)}/${id}/rows/${rowId}/attempts`).then(unwrap);
export const downloadCustomerImportErrors = (botId, id) => api.get(`${base(botId)}/${id}/errors.csv`, { responseType: "blob" }).then((response) => response.data);
